import { render, staticRenderFns } from "./ImgSvg.vue?vue&type=template&id=0117e189"
import script from "./ImgSvg.vue?vue&type=script&lang=js"
export * from "./ImgSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports